import { type TModalTSValues } from '@/types/financing';
import { type TRequestDetailed } from '@/types/request';

export const tsModalInfoMapper = (
  request: TRequestDetailed
): TModalTSValues => {
  // Код электрического двигателя - 4
  const isElectricVehicle = request?.engine_type?.code === 4;
  const usedCar = request?.used_car;

  return {
    requestUid: request?.uuid || '',
    vin:
      (request.is_online_request
        ? request.Online_Client_Requests?.[0]?.vehicle?.vin_code ||
          request?.vin_code
        : request?.vin_code || usedCar?.vin_code) || '',
    registerDate: request?.vehicle_registration_date || '',
    registerNum: request?.vehicle_registration_number?.toString() || '',
    paymentDate: request?.vehicle_first_payment_date || '',
    licensePlate: request?.vehicle_plate_number || '',
    carColor: request?.final_color_text || usedCar?.color || '',
    bodyNum: request?.vehicle_body_number?.toString() || '',
    engineCapacity: isElectricVehicle
      ? '0'
      : request?.vehicle_engine_capacity?.toString() ||
        usedCar?.engine_capacity?.toString() ||
        '',
    registerCompany:
      request?.vehicle_registration_company?.code?.toString() || ''
  };
};
